import SamplesList from 'components/GlobalModals/ProductSamplesModal/SamplesList/SamplesList';

export default SamplesList;
